<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filter-by-status
            ref="headerFilter"
            :filterStatus="filterStatus"
            :filterOptions="filterOptions"
            :title="'Văn bản dự thảo'"
            @filterByStatus="filterByStatus"
          />
        </template>
      </headerTemplate>
    </template>
    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div >
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>&nbsp;&nbsp;THÊM MỚI</span>
                    </div>
                  </el-button>

                </div>

                <div class=" margin-left-10">
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenMultiScanDocOutDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-search"></i>
                      <span>&nbsp;&nbsp;SCAN</span>
                    </div>
                  </el-button>
                </div>
                <div class=" margin-left-10">
                  <!--                hoang xuất kêt quả tìm kiếm -->
                  <el-tooltip class="item" effect="dark" content="Kết xuất kết quả tìm kiếm" placement="top-end">
                  <el-button
                    size="medium"
                    @click="chosenFileType"
                    type="primary">
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-export"></i>
                      <span>&nbsp;KẾT XUẤT</span>
                    </div>
                  </el-button>
                  </el-tooltip>
                </div>

                <searchTemplate
                  :keyword="keyword"
                  @simpleSearch="simpleSearch"
                  @search="isOpenAdvanceSearchDialog = true"
                >
                  <template #quickFilter>
                    <div class="flex-row margin-right-40">
                      <span class="style-fullWidth label-input margin-right-10 no_wrap">Quan trọng: </span>
                      <input
                        style="display: none"
                        type="checkbox"
                        ref="starCheckbox"
                        v-model="isStar"
                      >
                      <div class="theTitle__star" @click="isStarChange">
                        <i :class="{'fas fa-star' : isStar, 'fal fa-star' : !isStar}" />
                      </div>
                    </div>
                    <div
                      class="flex-row flex-left__top fix-width__large margin-right-10 custom-label__input"
                      v-if="
                        filterStatus == DU_THAO_PAGE.FILTER.ALL ||
                          filterStatus == DU_THAO_PAGE.FILTER.UY_QUYEN ||
                          filterStatus == DU_THAO_PAGE.FILTER.PHOI_HOP
                      "
                    >
                      <span class="label-input width__auto">Ngày tạo: </span>
                      <el-date-picker
                        v-model="createTimeRange"
                        type="daterange"
                        format="dd/MM/yyyy"
                        class="style-fullWidth input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="center"
                        :clearable="false"
                        @change="filterByCreateTimeRange"
                      >
                      </el-date-picker>
                    </div>
                    <div
                      class="flex-row flex-left__top fix-width__large margin-right-10 custom-label__input"
                      v-if="filterStatus == DU_THAO_PAGE.FILTER.CHO_XU_LY"
                    >
                      <span class="label-input width__auto">Ngày chuyển: </span>
                      <el-date-picker
                        v-model="processTimeRange"
                        type="daterange"
                        size="medium"
                        format="dd/MM/yyyy"
                        class="style-fullWidth bg input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="center"
                        :clearable="false"
                        @change="filterByProcessTime"
                      >
                      </el-date-picker>
                    </div>
                    <div
                      class="flex-row flex-left__top fix-width__large margin-right-10 custom-label__input"
                      v-if="filterStatus == DU_THAO_PAGE.FILTER.DA_XU_LY"
                    >
                      <span class="label-input width__auto">Ngày xử lý: </span>
                      <el-date-picker
                        v-model="vbDocUserUpdateTimeRange"
                        type="daterange"
                        size="medium"
                        format="dd/MM/yyyy"
                        class="style-fullWidth bg input-border__bottom input-border__radius__0 bg__transparent"
                        :picker-options="dateQuickFilterOption"
                        range-separator="_"
                        start-placeholder="_"
                        end-placeholder="_"
                        align="center"
                        :clearable="false"
                        @change="filterByVbDocUserUpdateTime"
                      >
                      </el-date-picker>
                    </div>
                    <div class="margin-right-10 txt-center fix-width__small">
                      <multiselect
                        :class="[docStatusFilter ? '' : '', 'style-fullWidth']"
                        :options="docStatusFilters"
                        label="name"
                        track-by="id"
                        v-model="docStatusFilter"
                        :preselect-first="true"
                        placeholder="-"
                        :multiple="false"
                        :close-on-select="true"
                        :clear-on-select="true"
                        :searchable="true"
                        open-direction="bottom"
                        @input="filterByDocStatus"
                      >
                        <template slot="noResult"
                          >Không tìm thấy dữ liệu phù hợp.
                        </template>
                        <template slot="noOptions"
                          >Danh sách trống
                        </template>
                        <template slot="singleLabel" slot-scope="{ option }">
                          <div
                            class="status-doc flex-row flex__left font-size__medium"
                          >
                            &nbsp;&nbsp;
                            <filterIconByStatus :status="option.id" />
                            <span>{{ option.name }}</span>
                          </div>
                        </template>
                      </multiselect>
                    </div>
                  </template>
                  <template #advance>
                    <duthao-advance-search-dialog
                      :isOpen="isOpenAdvanceSearchDialog"
                      :form="advanceSearchForm"
                      v-if="isEnableAdvanceSearchDialog"
                      @dialogClosed="isEnableAdvanceSearchDialog = false"
                      @closeDialog="isOpenAdvanceSearchDialog = false"
                      @doSearch="advanceSearch"
                    />
                  </template>
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <mainContent
              ref="mainContent"
              :sort="sort"
              :order="order"
              :sort-list="sortList"
              :advanceSearchForm="advanceSearchForm"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @deleteDoc="deleteDoc"
              v-if="filterStatus === DU_THAO_PAGE.FILTER.DA_XU_LY"
            />
            <mainContentAll
              ref="mainContent"
              :sort="sort"
              :order="order"
              :sort-list="sortList"
              :advanceSearchForm="advanceSearchForm"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @deleteDoc="deleteDoc"
              v-else-if="filterStatus === DU_THAO_PAGE.FILTER.ALL"
            />
            <mainContentChoXuLy
              ref="mainContent"
              :sort="sort"
              :order="order"
              :sort-list="sortList"
              :advanceSearchForm="advanceSearchForm"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @deleteDoc="deleteDoc"
              v-else-if="filterStatus === DU_THAO_PAGE.FILTER.CHO_XU_LY"
            />
            <main-content-uyquyen
              ref="mainContent"
              :sort="sort"
              :order="order"
              :sort-list="sortList"
              :advanceSearchForm="advanceSearchForm"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @deleteDoc="deleteDoc"
              v-else-if="filterStatus === DU_THAO_PAGE.FILTER.UY_QUYEN"
            />

            <main-content-phoihop
              ref="mainContent"
              :sort="sort"
              :order="order"
              :sort-list="sortList"
              :advanceSearchForm="advanceSearchForm"
              @doSort="doSort"
              @viewDetail="viewDetail"
              @deleteDoc="deleteDoc"
              v-else-if="filterStatus === DU_THAO_PAGE.FILTER.PHOI_HOP"
            />
          </template>
        </listTemplate>
      </div>

      <createDialog
        :isOpen="isOpenDialogCreate"
        v-if="isEnableDialogCreate"
        @closed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @success="createDocSuccess"
      />
      <multi-scan-doc-out-dialog
        :isOpen="isOpenMultiScanDocOutDialogCreate"
        v-if="isEnableMultiScanDocOutDialogCreate"
        @closed="isEnableMultiScanDocOutDialogCreate = false"
        @closeDialog="isOpenMultiScanDocOutDialogCreate = false"
        @success="createMultiScanDocSuccess"
      />
<!--      hoang chosen file type-->
      <chosen-file-type-dialog
        v-if="isOpenChosenFileTypeDialog"
        @closeDialog="isOpenChosenFileTypeDialog= false"
        @exportResult="exportResult"
        :is-open="true">
      </chosen-file-type-dialog>
    </template>
  </listTemplate>
</template>
<script>
import InfiniteLoading from "vue-infinite-loading";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import headerTemplate from "../../components/header/main-header.vue";
import constants from "../../constants";
import dateUtils from "../../dateUtils";
import { EventBus } from "../../event-bus.js";
import errorMessageFilter from "../../filters/errorMessageFilter";
import h from "../../services/h";
import outgoingDocService from "../../services/outgoingDocService";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import utils from "../../services/utils";
import listTemplate from "../common/list";
import searchTemplate from "../common/search";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import DuthaoAdvanceSearchDialog from "./components/duthao-advance-search-dialog";
import MainContentPhoihop from "./mainContentPhoiHop";
import MainContentUyquyen from "./mainContentUyQuyen";
import MultiScanDocOutDialog from "./multi-scan-doc-out-dialog";
import chosenFileTypeDialog from "./chosenFileTypeDialog";
import authenService from "../../services/authenService";
import {mapState, mapActions, mapGetters} from "vuex";

import vbOutgoingProcessService from "../../services/vbOutgoingProcessService";
import goBackMixin from "../../mixins/goBackMixin";
export default {
  mixins: [handleRequestErrorMixin, goBackMixin],
  components: {
    chosenFileTypeDialog,
    MultiScanDocOutDialog,
    MainContentPhoihop,
    DuthaoAdvanceSearchDialog,
    MainContentUyquyen,
    InfiniteLoading,
    listTemplate,
    headerTemplate,
    searchTemplate,
    VuePerfectScrollbar,
    subHeader: () => import("../../components/main/sub-header.vue"),
    createDialog: () => import("./components/CreateDialog.vue"),
    filterByStatus: () => import("./components/filter-by-status-header.vue"),
    mainContent: () => import("./mainContent.vue"),
    mainContentAll: () => import("./mainContentAll"),
    mainContentChoXuLy: () => import("./mainContentChoXuLy"),
    Multiselect: () => import("vue-multiselect"),
    filterIconByStatus: () => import("../common/filterIconStatusVban.vue")
  },

  mounted() {
    EventBus.$on(this.currentRoute, options => {
      this.isOpenDialogCreate = false;
      this.isOpenMultiScanDocOutDialogCreate = false;
      this.doSearch();
    });
    // this.initHeaderFilter();
  },

  data() {
    return {
      isOpenChosenFileTypeDialog:false,
      sortList: [],
      advanceSearchForm: {},
      sort: null,
      order: null,
      items: [],
      page: 0,
      size: 10,
      keyword: null,
      createTimeRange: null,
      processTimeRange: null,
      vbDocUserUpdateTimeRange: null,
      docStatusFilter: null,
      filterStatus: null,
      isStar: false,
      vbOutgoingProcessList: [],
      dateTitle: "Ngày tạo",
      dateQuickFilterOption: {
        shortcuts: [
          {
            text: "Hôm nay",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.HOM_NAY
                )
              );
            }
          },
          {
            text: "Tuần này",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.TUAN_NAY
                )
              );
            }
          },
          {
            text: "Năm nay",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.NAM_NAY
                )
              );
            }
          },
          {
            text: "1 tuần trước",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.LAST_WEEK
                )
              );
            }
          },
          {
            text: "1 tháng trước",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
                )
              );
            }
          },
          {
            text: "1 năm trước",
            onClick(picker) {
              picker.$emit(
                "pick",
                dateUtils.getDatesByQuickFilter(
                  constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
                )
              );
            }
          }
        ]
      },
      docStatusFilters: [
        { id: null, name: "Tất cả", level: 0 },
        { id: constants.OUTGOING_DOC_STATUS.TAOMOI, name: "Tạo mới", level: 1 },
        {
          id: constants.OUTGOING_DOC_STATUS.DANGXULI,
          name: "Đang trình ký",
          level: 2
        },
        {
          id: constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
          name: "Chờ ban hành",
          level: 3
        },
        {
          id: constants.OUTGOING_DOC_STATUS.TU_CHOI,
          name: "Từ chối",
          level: 4
        },
        {
          id: constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH,
          name: "Từ chối Ban hành",
          level: 5
        }
      ],
      filterOptions: [
        {
          value: constants.DU_THAO_PAGE.FILTER.ALL,
          label: "Tất cả",
          iconClass: null
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.CHO_XU_LY,
          label: "Chờ xử lý",
          iconClass: "fa-clock"
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.DA_XU_LY,
          label: "Đã xử lý",
          iconClass: "fa-check-circle"
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.PHOI_HOP,
          label: "Phối hợp"
          // iconClass: "fa-check-circle"
        },
        {
          value: constants.DU_THAO_PAGE.FILTER.DA_XOA,
          label: errorMessageFilter({
            errorCode: "vbOutgoingDoc.filterByStatus.daXoa"
          }),
          iconClass: "fa-trash"
        }
      ],
      isOpenMultiScanDocOutDialogCreate: false,
      isEnableMultiScanDocOutDialogCreate: false,
      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,
      perfectScrollbarSetting: { maxScrollbarLength: 350 },
      DOC_USER_STATUS: constants.DOC_USER_STATUS,
      DU_THAO_PAGE: constants.DU_THAO_PAGE,
    };
  },

  computed: {
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    globalConfigEditNode(){
      return authenService.getGlobalConfigEditNode()
    },

    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userId() {
      return this.$store.getters.user.id;
    },
    status() {
      switch (this.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
          return constants.DOC_USER_STATUS.CHO_XU_LY;
        case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
          return constants.DOC_USER_STATUS.DA_XU_LY;
        case constants.DU_THAO_PAGE.FILTER.ALL:
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
        default:
          return -1;
      }
    },
    ...mapState("outgoingDocs", ["eventData"]),
    ...mapGetters("outgoingDocs", ["requiresListReload"]),
  },

  watch: {
    isOpenDialogCreate(newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isOpenAdvanceSearchDialog(newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    },
    isOpenMultiScanDocOutDialogCreate(newValue) {
      newValue && (this.isEnableMultiScanDocOutDialogCreate = newValue);
    },
    eventData(newEvent) {
        if (this.requiresListReload) {
          console.log(`Reloading list due to event ${newEvent.action}`);
          this.doSearch()
          this.clearEvent(); // Reset the event after handling
        }
    }
  },

  created() {
    this.initQuery();
    this.initFilterOptions();
    this.registerEventBusForMaster(event => this.doSearch());
    // this.initDateRange();
  },

  methods: {
    ...mapActions("outgoingDocs", ["clearEvent"]),

    chosenFileType() {
      this.isOpenChosenFileTypeDialog = true
    },

    exportResult(item) {
      this.isOpenChosenFileTypeDialog = false
      this.$refs.mainContent.exportSearchResult(item, 'VAN_BAN_DU_THAO')
    },
    // initHeaderFilter() {
    //   console.log(this.$refs);
    //   // this.$refs.headerFilter.setFilterStatus(this.filterStatus);
    // },

    // initDateRange() {
    //   let rangeDate = dateUtils.getDatesByQuickFilter(
    //     constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
    //   );
    //   this.createTimeRange = rangeDate;
    //   this.fromCreateTime = this.fromProcessTime = rangeDate[0].getTime();
    //   this.toCreateTime = this.toProcessTime = rangeDate[1].getTime();
    // },

    // resetTime() {
    //   this.fromCreateTime = this.toCreateTime = this.fromProcessTime = this.toProcessTime = this.fromVbDocUserUpdateTime = this.toVbDocUserUpdateTime = null;
    // },

    filterByCreateTimeRange() {
      this.advanceSearchForm.fromCreateTime =
        this.createTimeRange && this.createTimeRange[0]
          ? this.createTimeRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toCreateTime =
        this.createTimeRange && this.createTimeRange[1]
          ? this.createTimeRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    filterByProcessTime() {
      this.advanceSearchForm.fromProcessTime =
        this.processTimeRange && this.processTimeRange[0]
          ? this.processTimeRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toProcessTime =
        this.processTimeRange && this.processTimeRange[1]
          ? this.processTimeRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    filterByVbDocUserUpdateTime() {
      console.log("filterByVbDocUserUpdateTime");
      this.advanceSearchForm.fromVbDocUserUpdateTime =
        this.vbDocUserUpdateTimeRange && this.vbDocUserUpdateTimeRange[0]
          ? this.vbDocUserUpdateTimeRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toVbDocUserUpdateTime =
        this.vbDocUserUpdateTimeRange && this.vbDocUserUpdateTimeRange[1]
          ? this.vbDocUserUpdateTimeRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    handleRequestError(error) {
      switch (error.errorCode) {
        case "vbOutgoingDoc.delete.statusMissMatch":
          this.$message({
            message: "Trạng thái văn bản không hợp lệ",
            type: "error"
          });
          return true;
        case "vbOutgoingDoc.delete.creatorMissMatch":
          this.$message({
            message: "Bạn không có quyền xóa văn bản này",
            type: "error"
          });
          return true;
      }
      return false;
    },
    deleteDoc(doc) {
      this.$confirm(`Bạn có muốn xóa Văn bản "${doc.quote}" ?`, "Thông báo", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy bỏ",
        type: "warning"
      }).then(() => {
        outgoingDocService
          .delete(doc.vbOutgoingDocUserViewKey.id)
          .then(() => {
            this.$message({
              message: "Xóa văn bản thành công",
              type: "success"
            });
            EventBus.$emit('loadCounting', '');
            this.doSearch();
          })
          .catch(error => this.commonHandleRequestError(error));
      });
    },

    createDocSuccess() {
      this.isOpenDialogCreate = false;
      this.doSearch();
    },
    createMultiScanDocSuccess() {
      this.isOpenMultiScanDocOutDialogCreate = false;
      this.message("Thông báo", "Scan văn bản thành công", "success", 2000)
      EventBus.$emit('loadCounting', '');
      this.doSearch();
    },
    initQuery() {
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        keyword: this.$route.query.keyword || undefined,
        filterStatus:
          this.$route.query.filterStatus ||
          constants.DU_THAO_PAGE.FILTER.CHO_XU_LY,
        docStatus: this.$route.query.docStatus || undefined,

        fromCreateTime: this.$route.query.fromCreateTime
          ? parseInt(this.$route.query.fromCreateTime)
          : undefined,
        toCreateTime: this.$route.query.toCreateTime
          ? parseInt(this.$route.query.toCreateTime)
          : undefined,

        fromVbDocUserUpdateTime: this.$route.query.fromVbDocUserUpdateTime
          ? parseInt(this.$route.query.fromVbDocUserUpdateTime)
          : undefined,
        toVbDocUserUpdateTime: this.$route.query.toVbDocUserUpdateTime
          ? parseInt(this.$route.query.toVbDocUserUpdateTime)
          : undefined,

        fromProcessTime: this.$route.query.fromProcessTime
          ? parseInt(this.$route.query.fromProcessTime)
          : undefined,
        toProcessTime: this.$route.query.toProcessTime
          ? parseInt(this.$route.query.toProcessTime)
          : undefined,

        docCode: this.$route.query.docCode || undefined,
        fileContent: this.$route.query.fileContent || undefined,
        docTypeId: this.$route.query.docTypeId || undefined,
        priorityId: this.$route.query.priorityId || undefined,
        quote: this.$route.query.quote || undefined,
        otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        publisherId: this.$route.query.publisherId || undefined,
        isStar: this.$route.query.isStar === "1" ? 1 : 0
      };

      this.filterStatus = this.advanceSearchForm.filterStatus;
      this.keyword = this.advanceSearchForm.keyword;
      this.initWhenFilterStatusChange();

      this.docStatusFilter = h.find(
        this.docStatusFilters,
        item => item.id == (this.advanceSearchForm.docStatus || null)
      );
      this.isStar = !!+this.$route.query.isStar;
    },

    initWhenFilterStatusChange() {
      switch (this.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.ALL:
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
        case constants.DU_THAO_PAGE.FILTER.PHOI_HOP:
          /**
           * init createTimeRange
           */
          if (
            this.advanceSearchForm.fromCreateTime ||
            this.advanceSearchForm.toCreateTime
          ) {
            this.createTimeRange = [
              dateUtils.toMoment(this.advanceSearchForm.fromCreateTime),
              dateUtils.toMoment(this.advanceSearchForm.toCreateTime)
            ];
          } else {
            this.createTimeRange = dateUtils.getDatesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            );
            let defaultTimeRange = dateUtils.getTimesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            );
            this.advanceSearchForm.fromCreateTime = defaultTimeRange[0];
            this.advanceSearchForm.toCreateTime = defaultTimeRange[1];
          }
          this.vbDocUserUpdateTimeRange = [null, null];
          this.processTimeRange = [null, null];
          this.advanceSearchForm.fromVbDocUserUpdateTime = this.advanceSearchForm.toVbDocUserUpdateTime = undefined;
          this.advanceSearchForm.fromProcessTime = this.advanceSearchForm.toProcessTime = undefined;
          break;
        case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
          /**
           * init processTimeRange
           */
          if (
            this.advanceSearchForm.fromProcessTime ||
            this.advanceSearchForm.toProcessTime
          ) {
            this.processTimeRange = [
              dateUtils.toMoment(this.advanceSearchForm.fromProcessTime),
              dateUtils.toMoment(this.advanceSearchForm.toProcessTime)
            ];
          } else {
            this.processTimeRange = dateUtils.getDatesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            );
            let defaultTimeRange = dateUtils.getTimesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            );
            this.advanceSearchForm.fromProcessTime = defaultTimeRange[0];
            this.advanceSearchForm.toProcessTime = defaultTimeRange[1];
          }
          this.createTimeRange = [null, null];
          this.vbDocUserUpdateTimeRange = [null, null];
          this.advanceSearchForm.fromCreateTime = this.advanceSearchForm.toCreateTime = undefined;
          this.advanceSearchForm.fromVbDocUserUpdateTime = this.advanceSearchForm.toVbDocUserUpdateTime = undefined;
          break;
        case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
          /**
           * init vbDocUserUpdateTimeRange
           */
          if (
            this.advanceSearchForm.fromVbDocUserUpdateTime ||
            this.advanceSearchForm.toVbDocUserUpdateTime
          ) {
            this.vbDocUserUpdateTimeRange = [
              dateUtils.toMoment(
                this.advanceSearchForm.fromVbDocUserUpdateTime
              ),
              dateUtils.toMoment(this.advanceSearchForm.toVbDocUserUpdateTime)
            ];
          } else {
            this.vbDocUserUpdateTimeRange = dateUtils.getDatesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            );
            let defaultTimeRange = dateUtils.getTimesByQuickFilter(
              constants.DATE_QUICK_FILTER.CODE.LAST_YEAR
            );
            this.advanceSearchForm.fromVbDocUserUpdateTime =
              defaultTimeRange[0];
            this.advanceSearchForm.toVbDocUserUpdateTime = defaultTimeRange[1];
          }
          this.createTimeRange = [null, null];
          this.processTimeRange = [null, null];
          this.advanceSearchForm.fromCreateTime = this.advanceSearchForm.toCreateTime = undefined;
          this.advanceSearchForm.fromProcessTime = this.advanceSearchForm.toProcessTime = undefined;
          break;
      }
    },

    buildQuery() {
      return utils.merge(
        {sort: this.sort || "updateTime", order: this.order || "desc"},
        this.advanceSearchForm
      );
    },

    filterByStatus(event) {
      switch (event.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.DA_XOA:
          this.routingToVbDaXoaPage();
          break;

        default:
          this.advanceSearchForm.filterStatus = this.filterStatus =
            event.filterStatus;
          this.initWhenFilterStatusChange();
          this.doSearch();
      }
    },

    routingToVbDaXoaPage() {
      this.$router.push({
        name: "deletedDocOutIndex",
        params: {
          userDeptRoleId: this.userDeptRoleId
        }
      });
    },

    filterByDocStatus(event) {
      this.advanceSearchForm.docStatus = event.id;
      this.doSearch();
    },

    simpleSearch(keyword) {
      console.log("keyword");
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.advanceSearchForm.priorityId = undefined;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.publisherId = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.otherReceivePlaces = undefined;
      this.doSearch();
    },

    advanceSearch(event) {
      let advanceSearchForm = event.advanceSearchForm;
      this.sortList = event.sortList;
      this.advanceSearchForm.keyword = undefined;
      this.keyword = null;
      this.advanceSearchForm.quote = advanceSearchForm.quote || undefined;
      this.advanceSearchForm.fileContent =
        advanceSearchForm.fileContent || undefined;
      this.advanceSearchForm.priorityId =
        advanceSearchForm.priorityId || undefined;
      this.advanceSearchForm.docTypeId =
        advanceSearchForm.docTypeId || undefined;
      this.advanceSearchForm.publisherId =
        advanceSearchForm.publisherId || undefined;
      this.advanceSearchForm.receiveDeptId =
        advanceSearchForm.receiveDeptId || undefined;
      this.advanceSearchForm.otherReceivePlaces =
        advanceSearchForm.otherReceivePlaces || undefined;
      this.advanceSearchForm.sortList =
        event.sortList || undefined;
      this.doSearch();
    },

    doSort(event) {
      this.sort = event.sort;
      this.order = event.order;
      this.doSearch();
    },
    loadVbOutgoingProcess(id){
      vbOutgoingProcessService.findById(id).then(res => {
        this.vbOutgoingProcessList = res.data;;
      });
    },


    doSearch() {
      this.$router.replace({
        name: "vbDuThaoNew",
        params: this.$route.params,
        query: this.buildQuery()
      });
      this.$refs.mainContent && this.$refs.mainContent.doSearch();
    },

    viewDetail(item) {
      if(this.globalConfigEditNode)
      {
        vbOutgoingProcessService.findById(item.vbDocUserVbDocProcessId).then(res => {
          this.vbOutgoingProcessList = res.data;
        }).then(() => {
          if (
            !item.vbDocUserVbDocProcessId &&
            (item.status == constants.OUTGOING_DOC_STATUS.TAOMOI ||
              ((item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI ||
                  item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH) &&
                item.editorId == this.userId))
          ) {
            this.$router.push({
              name: "vbDuThaoNewEdit",
              params: {
                userDeptRoleId: this.userDeptRoleId,
                id: item.vbOutgoingDocUserViewKey.id
              },
              query: this.$route.query
            });
          }
          // Nếu văn bản có trang thái đang xử lý, user đang login có role lãnh đạo thì cho phép user sửa văn bản
          else if (
            item.vbDocUserVbDocProcessId &&
            this.vbOutgoingProcessList.status === constants.OUTGOING_PROCESS_STATUS.CHO_XU_LY &&
            item.status == constants.OUTGOING_DOC_STATUS.DANGXULI &&
            this.userDeptRole.roleCode == constants.ROLE.CODE.LANH_DAO

          ) {
            let query = utils.merge(this.$route.query, {
              vbDocProcessId: item.vbDocUserVbDocProcessId
            });
            this.$router.push({
              name: "vbDuThaoLanhDaoEdit",
              params: {
                userDeptRoleId: this.userDeptRoleId,
                id: item.vbOutgoingDocUserViewKey.id
              },
              query: query
            });
          }
          else {
            let query = utils.merge(this.$route.query, {
              vbDocProcessId: item.vbDocUserVbDocProcessId
            });
            this.$router.push({
              name: "vbDuThaoNewDetail",
              params: {
                userDeptRoleId: this.userDeptRoleId,
                id: item.vbOutgoingDocUserViewKey.id
              },
              query: query
            });
          }
        })
      }
      else{
        if (
          !item.vbDocUserVbDocProcessId &&
          (item.status == constants.OUTGOING_DOC_STATUS.TAOMOI ||
            ((item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI ||
                item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH) &&
              item.editorId == this.userId))
        ) {
          this.$router.push({
            name: "vbDuThaoNewEdit",
            params: {
              userDeptRoleId: this.userDeptRoleId,
              id: item.vbOutgoingDocUserViewKey.id
            },
            query: this.$route.query
          });
        }

        else {
          let query = utils.merge(this.$route.query, {
            vbDocProcessId: item.vbDocUserVbDocProcessId,
            isAssistantSign: item.userId == this.userId ? 0 : 1
          });
          this.$router.push({
            name: "vbDuThaoNewDetail",
            params: {
              userDeptRoleId: this.userDeptRoleId,
              id: item.vbOutgoingDocUserViewKey.id
            },
            query: query
          });
        }
      }

    },

    /**
     * neu la quyen lanh dao thi moi them tab uy quyen;
     */
    initFilterOptions() {
      userDeptRoleViewService.findById(this.userDeptRoleId).then(response => {
        let userDeptRoleView = response.data;
        userDeptRoleView.roleCode === constants.ROLE.CODE.LANH_DAO &&
        this.filterOptions.push({
          value: constants.DU_THAO_PAGE.FILTER.UY_QUYEN,
          label: "Ủy quyền",
          iconClass: null
        });
      });
    },

    isStarChange(value) {
      this.$refs.starCheckbox.click();
      const isStar = this.$refs.starCheckbox.checked ? 1 : 0;
      this.advanceSearchForm.isStar = isStar;
      this.doSearch();
    },
  }
};
</script>

<style scoped>
/*#searchBox {*/
/*  position: relative;*/
/*  width: 100%;*/
/*}*/

/*.advance-search {*/
/*  font-size: 17px;*/
/*  color: #005eb1;*/
/*  position: absolute;*/
/*  right: 5%;*/
/*  top: 50%;*/
/*  transform: translateY(-50%);*/
/*}*/

/*.icon-info {*/
/*  background-color: #f0c330;*/
/*  border-radius: 50%;*/
/*  width: 15px;*/
/*  height: 15px;*/
/*  margin-top: -1px;*/
/*  margin-left: 2px;*/
/*}*/

/*.text-bold {*/
/*  font-weight: bold;*/
/*}*/

/*.quick-filter {*/
/*  background-color: rgba(90, 163, 51, 0.5);*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/views/doc-out/NewIndex.vue